<div class="h-14"></div>
<div class="mx-auto max-w-sm space-y-6 p-6 md:py-40">
  <img
    class="mx-auto w-40"
    src="/assets/image/hexa-tick-brand.png" />
  <div class="-mt-8 space-y-3 text-center">
    <p class="text-text-default px-14 text-lg font-bold md:px-0">Pin Baru Berhasil di Simpan</p>
    <p class="text-text-subtle px-10 text-sm md:px-0">
      Pakai pin barumu untuk masuk ke aplikasi, jangan lupa untuk tetap menjaga kerahasiaan pin
      kamu.
    </p>
  </div>
  <app-button
    class="mx-auto block w-44"
    styleClass="h-10"
    (click)="completed.emit()">
    Masuk
  </app-button>
</div>
